<div class="offcanvas-container">
  <div class="offcanvas-header">
    <h4 class="offcanvas-title">Confirm Deletion</h4>
    <button type="button" class="btn-close" (click)="cancel()" aria-label="Close"></button>
  </div>

  <div class="offcanvas-body">
    <p>
      Are you sure you want to delete <strong>{{ item.name }}</strong>?
    </p>
  </div>

  <div class="offcanvas-footer p-3 d-flex justify-content-end">
    <button type="button" class="secondaryBtn me-2" (click)="cancel()">Cancel</button>
    <button type="button" class="btn btn-danger" (click)="confirmDelete()">Delete</button>
  </div>
</div>
